import React from 'react'
import { aboutText } from '../data/aboutData'
import '../styles/global.scss'
import styles from '../styles/About.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'

export const About = () => {

    return (
        <div id="about" className='container'>
            <h2 className="title">Sobre</h2>
            <div>
                {aboutText.map((paragraph) => <p className={styles.paragraph}>{paragraph}</p>)}
                <a className='cta' href={process.env.PUBLIC_URL + '/cv-julia-lacerda.pdf'} download='cv-julia-lacerda.pdf'>Baixar currículo <FontAwesomeIcon className='ctaIcon' icon={faDownload}/></a>
            </div>
        </div>
    )
}
